import React from 'react'
import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import {history} from '../helpers/common'
import OuterLayout from  './../layouts/OuterLayout'
import InnerLayout from  './../layouts/InnerLayout'
import {RouteWithLayout} from '../layouts/RouteWithLayout'

import * as pages from '../components'

const AppRouter =()=>{
    return(
        <Router history={history}>
            <Switch>
                <RouteWithLayout layout={OuterLayout} path='/admin-login' component={pages.Login}/>
                <RouteWithLayout layout={InnerLayout} path='/admin' component={pages.Dashboard}/>
            </Switch>
        </Router>
    )
}
export default AppRouter
